import React, { FC } from 'react';
import { FenceComponent } from 'src/components/Fence';

interface Props {}

export const FencePage: FC<Props> = () => {
  return <FenceComponent />;
};
